import React from 'react';
import { LeafIcon, LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const handleNavClick = (page: string) => {
    if (onNavigate) {
      onNavigate(page);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#1a1a1a] text-white pt-20 pb-10" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-16" data-id="element-100">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1" data-id="element-101">
            <button onClick={() => handleNavClick('home')} className="flex items-center gap-2.5 mb-6" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/uNzxRhCv2aCUAsyC2zwLfQ/Greenwater_logo.jpg" alt="Greenwater Logo" className="h-9 w-9 rounded-full object-cover ring-2 ring-white/10" data-id="element-103" />
              <span className="text-xl tracking-wide" data-id="element-104">
                <span className="font-extrabold text-gesl-gold" data-id="element-105">GREEN</span>
                <span className="font-light text-white" data-id="element-106">WATER</span>
              </span>
            </button>
            <p className="text-white/60 text-sm leading-relaxed mb-6" data-id="element-107">
              Delivering Sustainable Environmental Solutions for Responsible
              Development since 2000.
            </p>
            <div className="flex gap-4" data-id="element-108">
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gesl-gold transition-colors" data-id="element-109">
                <LinkedinIcon className="h-5 w-5" data-id="element-110" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gesl-gold transition-colors" data-id="element-111">
                <TwitterIcon className="h-5 w-5" data-id="element-112" />
              </a>
              <a href="mailto:info@greenwater.ng" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gesl-gold transition-colors" data-id="element-113">
                <MailIcon className="h-5 w-5" data-id="element-114" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-115">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-116">Quick Links</h4>
            <ul className="space-y-3" data-id="element-117">
              {[{
              label: 'About Us',
              page: 'about'
            }, {
              label: 'Our Services',
              page: 'services'
            }, {
              label: 'Industries',
              page: 'industries'
            }, {
              label: 'Projects',
              page: 'projects'
            }, {
              label: 'Technical Team',
              page: 'team'
            }, {
              label: 'Contact',
              page: 'contact'
            }].map(link => <li key={link.label} data-id="element-118">
                  <button onClick={() => handleNavClick(link.page)} className="text-white/60 hover:text-gesl-gold transition-colors text-sm" data-id="element-119">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-120">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-121">Core Services</h4>
            <ul className="space-y-3" data-id="element-122">
              {['Environmental Assessment', 'Compliance Monitoring', 'Sustainability Advisory', 'Project Development', 'ESG Consulting'].map(service => <li key={service} data-id="element-123">
                  <button onClick={() => handleNavClick('services')} className="text-white/60 hover:text-gesl-gold transition-colors text-sm" data-id="element-124">
                    {service}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-125">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-126">Contact Us</h4>
            <address className="not-italic text-white/60 text-sm space-y-3" data-id="element-127">
              <p data-id="element-128">
                Suite 3, 23 IT Igbani Street
                <br data-id="element-129" />
                Jabi, Abuja, Nigeria
              </p>
              <p data-id="element-130">
                <a href="tel:+2348034612933" className="hover:text-gesl-gold transition-colors" data-id="element-131">
                  +234 803 461 2933
                </a>
              </p>
              <p data-id="element-132">
                <a href="mailto:info@greenwater.ng" className="hover:text-gesl-gold transition-colors" data-id="element-133">
                  info@greenwater.ng
                </a>
              </p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-134">
          <p className="text-white/40 text-sm text-center md:text-left" data-id="element-135">
            © {new Date().getFullYear()} Greenwater Environmental Services
            Limited. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-white/40" data-id="element-136">
            <a href="#" className="hover:text-white transition-colors" data-id="element-137">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-138">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}